<!-- =========================================================================================

  説明: ダイアログで退職処理を行うコンポーネント
  作成者: Kokichi

========================================================================================== -->

<template>
  <div>
    <vs-prompt
      @accept="execute"
      @cancel="cancel"
      @close="close"
      :title="title"
      :accept-text="acceptText"
      :cancel-text="cancelText"
      :active.sync="active"
      :is-valid="validateForm"
    >
      <div class="con-exemple-prompt">
        <b>{{ userName }}</b
        >さんの退職日を入力し実行ボタンを押してください
        <vs-input
          class="mt-4 mb-2 w-full"
          label="退職日"
          placeholder="2020-01-23"
          v-model="inputValue"
          v-validate="'required|date_format:yyyy-MM-dd|custom_retirementDateIsNotFuture'"
          key="retirement_date"
          name="retirement_date"
          data-vv-as="退職日"
        />
        <span
          class="text-danger text-sm"
          v-show="errors.has('retirement_date')"
          >{{ errors.first("retirement_date") }}</span
        >
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import moment from "moment";
import ValidationUtil from "@/utils/entity/ValidationUtil";
import { AiseaApiFactory } from "@/api/aisea/apiFactory";

export default {
  data() {
    return {
      userData: null,
      userName: "",
      title: "退職処理",
      acceptText: "実行",
      cancelText: "キャンセル",
      active: false,
      isValid: false,
      inputValue: "",
      DATE_FORMAT: "YYYY-MM-DD"
    };
  },
  computed: {
    validateForm() {
      return (
        moment(this.inputValue, this.DATE_FORMAT).format(this.DATE_FORMAT) === this.inputValue
        && !ValidationUtil.isFutureDate(moment(this.inputValue, this.DATE_FORMAT))
      );
    }
  },
  watch: {
    active(val) {
      if ( val ) {
        this.inputValue = "";
      }
    },
  },
  methods: {
    show(userData) {
      if (userData) {
        this.userData = userData;
        this.userName = this.userData.name;
        this.active = true;
      }
    },
    async execute() {
      try {
        this.$vs.loading();
        let payload = JSON.parse(JSON.stringify(this.userData));
        payload.retirement_date = this.inputValue;
        await AiseaApiFactory.get("enterpriseUser").save(
          this.userData.id,
          payload
        );
        this.$vs.loading.close();
        this.$emit("completeRetirement");
      } catch (e) {
        this.$vs.loading.close();
        this.failureDelete(e);
      }
    },
    successDelete() {
      this.$vs.notify({
        title: this.userName + "さんの退職処理をしました",
        color: "success",
        iconPack: "feather",
        icon: "icon-check"
      });
    },
    failureDelete(e) {
      console.error(e);
      this.$vs.notify({
        title: "退職処理に失敗しました",
        color: "danger",
        iconPack: "feather",
        icon: "icon-x-square"
      });
    },
    close() {
      this.active = false;
    },
    cancel() {
      this.active = false;
    },
    addCustomRetirementValidator() {
      this.$validator.extend("custom_retirementDateIsNotFuture", {
        getMessage: () => "退職年月日には本日以前の日付を入力してください",
        validate: value => {
          const valueDate = moment(value, this.DATE_FORMAT).toDate();
          return !ValidationUtil.isFutureDate(valueDate);
        }
      });
    },
  },
  created() {
    this.addCustomRetirementValidator();
  },
};
</script>
